import {
  TechDocsReaderPageContent,
  TechDocsReaderPageHeader,
} from '@backstage/plugin-techdocs';
// import Navbar from '../Navbar/navbar';
// import { Sidebar } from '../Navbar/Sidebar';
import { Layout } from '../Navbar/Layout';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh', // Ensure it fills screen but grows
    width: '100%',
  },
  content: {
    flexGrow: 1,
    // overflow: 'auto', // Removed to eliminate inner scrollbar
  },
});

export const CustomTecDocsReaderPage = () => {
    const classes = useStyles();
  return (
    <Layout>
      <div className={classes.root}>
        {/* <Navbar /> */}
        {/* <Sidebar /> */}
        <div className={classes.content}>
          <TechDocsReaderPageHeader />
          <TechDocsReaderPageContent withSearch={false} />
        </div>
      </div>
    </Layout>
  );
};
